// Colors

// Based on wheel.svg structure (222 paths total):
// path 1 = Text 1 "EXPANDING DEPLOYMENTS" (fill)
// path 2 = Text 2 "ENRICHED ONTOLOGY & TEMPLATES" (fill)
// path 3 = Text 3 "ENHANCED AI CAPABILITIES" (fill)
// path 4 = Hexagon 1 border (stroke only!)
// path 5 = Hexagon 2 border (stroke only!)
// path 6 = Hexagon 3 border (stroke only!)
// paths 7-78 = Arrow 1 dots (right arrow, Hex1→Hex2)
// paths 79-150 = Arrow 2 dots (down-left arrow, Hex2→Hex3)
// paths 151-222 = Arrow 3 dots (up-left arrow, Hex3→Hex1)

// Selectors for each element
export const TEXT_1 = "path:nth-child(1)";
export const TEXT_2 = "path:nth-child(2)";
export const TEXT_3 = "path:nth-child(3)";
export const HEX_1 = "path:nth-child(4)";
export const HEX_2 = "path:nth-child(5)";
export const HEX_3 = "path:nth-child(6)";

// Arrow selectors using nth-child ranges
export const ARROW_1 = "path:nth-child(n+7):nth-child(-n+78)";
export const ARROW_2 = "path:nth-child(n+79):nth-child(-n+150)";
export const ARROW_3 = "path:nth-child(n+151):nth-child(-n+222)";

// Animation timing
export const LIGHT_UP_DURATION = 0.4; // Fast light up (activation)
export const FADE_OUT_DURATION = 0.8; // Slower fade out (deactivation)
export const HOLD_DURATION = 0.3; // Longer wheel highlight time
export const ARROW_DURATION = 0.6; // Shorter arrow display
export const OVERLAP_DELAY = 0.6; // Delay before wheel starts (creates overlap with arrow)

// Section content
export const sectionTitle = "Ontology Flywheel Advantage";

export const sectionDescription =
  "With every new deployment, the ontology becomes richer and unlocks faster time-to-value. That momentum creates a self-reinforcing moat and drives ever-higher adoption and ROI.";
